import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import PatientService from '@/services/patient'
import UserService from '@/services/user'
import store from './store'

import auth from './middleware/auth'
import log from './middleware/log'
import auth_token_from_url from './middleware/auth_token_from_url'
import StorageService from '@/services/storage'


Vue.use(Router)
Vue.use(Meta)

async function checkPatientCount() {
  if (store.state.patientCount.length === 0 || typeof store.state.patientCount !== 'number') {
    await store.dispatch('allPatients')
  }
}


async function checkPatientCountForMobile() {
  if (store.state.patientCount.length === 0 || typeof store.state.patientCount !== 'number') {
    await store.dispatch('allPatientsForMobile')
  }
}

async function setUser() {
  if (store.state.role != 'admin' || store.state.role != 'user') {
    await store.dispatch('getUser')
  }
}

async function setCurrentPatientId(patientId) {
  await store.dispatch('getPatientId', patientId)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/app/auth',
      meta: {
        middleware: log
      },
      component: () => import(/* webpackChunkName: "auth" */ './views/AuthLayout.vue'),
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import(/* webpackChunkName: "login" */ './components/login/Page.vue')
        },
        {
          path: 'register',
          name: 'register',
          component: () => import(/* webpackChunkName: "register" */ './components/register/Registration.vue')
        },
        {
          path: 'forgot',
          name: 'forgot',
          component: () => import(/* webpackChunkName: "forgot" */ './components/login/ForgotPassword.vue')
        },
        {
          path: 'activation/:confirmation_token',
          name: 'activation',
          component: () => import(/* webpackChunkName: "forgot" */ './components/register/AccountActivation.vue')
        },
        {
          path: 'activation',
          name: 'resendActivation',
          component: () => import(/* webpackChunkName: "forgot" */ './components/register/ResendActivation.vue')
        },
        {
          path: 'change-password/:token',
          name: 'changePassword',
          component: () => import(/* webpackChunkName: "forgot" */ './components/login/ChangePassword.vue')
        }
      ]
    },
    {
      path: '/app',
      component: () => import(/* webpackChunkName: "root" */ './views/AppLayout.vue'),
      children: [
        {
          path: '',
          name: 'home',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/Home.vue')
        },
        {
          path: 'me',
          name: 'me',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/user/Edit.vue')
        },
        {
          path: 'patients',
          name: 'patients',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            if (store.state.patients === '' || store.state.patients.length === 0) {
              next({path: ''})
            } else {
              next()
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/patient/Index.vue'),
        },
        {
          path: 'patients/new',
          name: 'newPatient',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/patient/New.vue')
        },
        {
          path: 'patients/:id',
          name: 'showPatient',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/patient/Show.vue')
        },
        {
          path: 'settings/lov',
          name: 'lov',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role == 'admin') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/lov/Index.vue')
        },
        {
          path: 'exam-registry',
          name: 'examRegistry',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/exams/Registry.vue')
        },
        {
          path: 'emergency-certificates',
          name: 'emergencyCertificates',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import('./components/patient/CertificateList.vue')
        },
        {
          path: 'informations',
          name: 'informations',
          beforeEnter: async (to, from, next) => {
            await setUser()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import('./components/Informations.vue')
        },
        {
          path: 'news',
          name: 'publicNews',
          beforeEnter: async (to, from, next) => {
            await setUser()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import('./components/news/List.vue')
        },
        {
          path: 'news/manage',
          name: 'newsList',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role == 'admin') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/news/Index.vue')
        },
        {
          path: 'news/manage/new',
          name: 'newArticle',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role == 'admin') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/news/New.vue')
        },
        {
          path: 'news/manage/:id',
          name: 'editArticle',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role == 'admin') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/news/Edit.vue')
        },
        {
          path: 'news/:slug',
          name: 'articleDetails',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import('./components/news/Show.vue')
        },
        {
          path: 'support',
          name: 'support',
          beforeEnter: async (to, from, next) => {
            await setUser()
            await checkPatientCount()
            next()
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import('./components/suggestions/New.vue')
        },
        {
          path: 'users',
          name: 'users',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role == 'admin') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/user/Index.vue')
        },
        {
          path: 'users/new',
          name: 'newUser',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role == 'admin') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/user/New.vue')
        },
        {
          path: 'users/:id/edit',
          name: 'editUser',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role == 'admin') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/user/EditUser.vue')
        },
        {
          path: 'seizures/:id',
          name: 'showSeizure',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role === 'admin' || store.state.user.role === 'dravetnet') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/seizure/Show.vue')
        },
        {
          path: 'reports/drug',
          name: 'drugReport',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role === 'admin' || store.state.user.role === 'dravetnet') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/reports/Drug.vue')
        },
        {
          path: 'reports/user',
          name: 'userReport',
          beforeEnter: async (to, from, next) => {
            await setUser()
            if (store.state.user.role === 'admin' || store.state.user.role === 'dravetnet') {
              next()
            } else {
              next({path: ''})
            }
          },
          meta: {
            middleware: [auth, log]
          },
          component: () => import(/* webpackChunkName: "home" */ './components/reports/User.vue')
        }
      ]
    },
    {
      path: '/mobileSeizureGraph',
      component: () => import(/* webpackChunkName: "mobile" */ './components/patient/SeizureGraphForMobile.vue'),
      beforeEnter: async (to, from, next) => {
        if (to.query.t ) {
          StorageService.setItem('mobileToken', to.query.t)
        }
        await setCurrentPatientId(to.query.patientId)
        await checkPatientCountForMobile()
        next()
      }
    }
  ]
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters)
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to
    }
    const nextMiddleware = nextFactory(context, middleware, 1)
    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
